// Single source of truth for the API base URL.
//
//   Web prod (served by Express same-origin) → '/api'        (relative)
//   Web dev (CRA dev server on :3000)        → 'http://localhost:5500/api'
//   Capacitor iOS/Android shell              → 'https://www.ranga.com/api'
//
// The Capacitor branch is necessary because the native webview loads the
// React bundle from `capacitor://localhost`, so a relative `/api` URL would
// hit the in-app webserver (which has no API) instead of our backend.
//
// All callers should import API_BASE_URL from here — avoid recomputing the
// branch inline in components, otherwise the Capacitor build will silently
// route around this and 404 every request.
import { Capacitor } from '@capacitor/core';

const PROD_HOST = 'https://www.ranga.com';

function computeHost() {
  if (Capacitor.isNativePlatform()) return PROD_HOST;
  if (process.env.NODE_ENV === 'production') return '';
  return 'http://localhost:5500';
}

// Host with no path. Use for non-/api endpoints like /health.
export const SERVER_HOST = computeHost();

// /api-rooted URL. Use for all backend API calls.
export const API_BASE_URL = `${SERVER_HOST}/api`;
